<template>
  <Modal :open="open" @close="close">
    <div>
      <h1 class="text-center font-extrabold text-xl">{{ t("title") }}</h1>

      <div v-if="hasBlockers" class="mt-4 space-y-2">
        <Alert v-if="blockers.paymentsNotUpToDate" type="error">{{ t("blockers.payments_not_up_to_date") }}</Alert>
        <Alert v-if="blockers.withinCommitmentPeriod" type="warning">
          {{ t("blockers.within_commitment_period") }}
        </Alert>
        <Alert v-if="blockers.hasApprovedClaim" type="error">{{ t("blockers.has_approved_claim") }}</Alert>
      </div>

      <FormField
        id="cancellationDate"
        name="cancellationDate"
        class="mt-6"
        type="date"
        :label="t('cancellation_date')"
        v-model="cancellationDate"
      />
      <Selector
        id="cancellationReason"
        name="cancellationReason"
        class="mt-4"
        :label="t('reason')"
        :options="reasonOptions"
        :defaultOptionText="t('reason_placeholder')"
        v-model="cancellationReason"
      />
      <Textarea id="feedbackMessage" class="mt-4" :label="t('feedback_message')" v-model="feedbackMessage" />

      <div class="mt-6 flex justify-center">
        <GenericButton @click="submit">{{ t("submit") }}</GenericButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  Modal,
  GenericButton,
  Alert,
  FormField,
  Selector,
  Textarea,
  hasCancellationBlockers,
  OPS_CANCELLATION_REASONS,
} from "@estaly/ui";
import { useI18n } from "vue-i18n";

const today = () => new Date().toISOString().split("T")[0];

export default {
  name: "CancellationModal",

  components: { Modal, GenericButton, Alert, FormField, Selector, Textarea },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    planSale: {
      type: Object,
      required: true,
    },
  },

  emits: ["close", "cancel-plan-sale"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      cancellationDate: today(),
      cancellationReason: "",
      feedbackMessage: "",
    };
  },

  computed: {
    blockers() {
      return this.planSale?.cancellationBlockers ?? {};
    },

    hasBlockers() {
      return hasCancellationBlockers(this.blockers);
    },

    reasonOptions() {
      return OPS_CANCELLATION_REASONS.map((reason) => ({ value: reason, label: this.t(`reasons.${reason}`) }));
    },
  },

  methods: {
    submit() {
      this.$emit("cancel-plan-sale", {
        cancellationDate: this.cancellationDate,
        cancellationReason: this.cancellationReason,
        feedbackMessage: this.feedbackMessage,
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>

<i18n src="./CancellationModal.i18n.json"></i18n>
